/**
 * Custom Featured Collection Slider
 */

const initCustomFeaturedSlider = () => {
    const swiperContainers = document.querySelectorAll('.custom-featured-swiper');

    swiperContainers.forEach(container => {
        // Prevent duplicate initialization / listeners
        if (container.dataset.customSliderAttached) return;
        container.dataset.customSliderAttached = 'true';

        let swiperInstance = null;

        const initSwiper = () => {
            if (swiperInstance) return;
            swiperInstance = new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 0,
                grabCursor: true,
                scrollbar: {
                    el: container.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    hide: false,
                },
                breakpoints: {
                    749: {
                        slidesPerView: 2,
                        spaceBetween: 12,
                    }
                }
            });
        };

        const destroySwiper = () => {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };

        const handleResize = () => {
            const mobileLayout = container.dataset.mobileLayout;
            if (mobileLayout === 'stack') {
                destroySwiper();
                return;
            }

            if (window.innerWidth <= 992) {
                initSwiper();
            } else {
                destroySwiper();
            }
        };

        // Initial check
        handleResize();

        // Listen for resize
        window.addEventListener('resize', handleResize);
    });
};

document.addEventListener('DOMContentLoaded', initCustomFeaturedSlider);

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        if (event.target.classList.contains('section-custom-featured-collection') || event.target.querySelector('.custom-featured-swiper')) {
            initCustomFeaturedSlider();
        }
    });
}
